import { Typography } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';
import { HtmlView } from '../LearningCollection/CurrentCollectionStep/BuilderV2/ExperienceHtmlView';

interface Props {
  description: Maybe<string>;
}

function Description({ description }: Props) {
  return description
    .map((description) => <HtmlView description={description} />)
    .getOrElse(() => (
      <Typography variant="bodyLarge" className="text-gray-500">
        <T kind="Collection description will appear here" />
      </Typography>
    ));
}

export default observer(Description);
